import "@styles/base/core/menu/menu-types/vertical-menu.scss";
import "@styles/base/core/menu/menu-types/vertical-overlay-menu.scss";

import { getItemFromStore, handleMenuCollapsed, setItemToStore } from "@helpers/utils";
import { useContext, useEffect, useLayoutEffect, useState } from "react";
import { useLocation, useMatch, useNavigate } from "react-router-dom";

import { AbilityContext } from "@context/can";
import { Navbar } from "reactstrap";
import NavbarComponent from "@layouts/components/navbar";
import SidebarComponent from "@layouts/components/menu";
import axios from "axios";
import classnames from "classnames";
import { confirmAlert } from "@helpers/toast";
import useNavigation from "../../../navigation";
import useWindowSize from "@hooks/use-window-size";

const Layout = (props) => {

    const { routes, children } = props;

    const [menuHidden, setMenuHidden] = useState(false);
    const { pathname } = useLocation();
    const routeMatch = useMatch(pathname);
    const navigate = useNavigate();

    useLayoutEffect(() => {
        setMenuHidden(routes.find((route) => route.path === routeMatch.pathnameBase)?.meta.menuHidden);
    }, [pathname]);

    const { panel:productPanel, bottomNavigation, account, superadmin } = useNavigation();

    const isProductRoute = pathname.includes("platforms");

    const handleNavigation = () => {
        let panel = {};
        let bottom = [];

        if (pathname.includes("account")) {
            panel = account;
            bottom = bottomNavigation.filter(item => item.id === "logout");
        } else if (pathname.includes("superadmin")) {
            panel = superadmin;
            bottom = bottomNavigation.filter(item => item.id === "logout");
        } else {
            panel = productPanel;
            bottom = bottomNavigation;
        }

        return { panel, bottomNavigation: bottom };
    };
    const menuData = handleNavigation();

    // ** Hooks
    const ability = useContext(AbilityContext);
    // const { loading } = useContext(AppContext);

    // ** States
    const [menuVisibility, setMenuVisibility] = useState(false);
    const { windowWidth } = useWindowSize();

    // ** Vars
    const location = useLocation();
    const [menuCollapsed, setMenuCollapsed] = useState(false);
    const isMenuHidden = menuHidden;
    const showNavbar = menuHidden ? true : windowWidth <= 1111;
    const storedVersion = getItemFromStore("appVersion");
    const [popupOpen, setPopupOpen] = useState(false);
    
    //** This function will detect the Route Change and will hide the menu on menu item click
    useEffect(() => {
        if (menuVisibility && windowWidth < 1111) {
            setMenuVisibility(false);
        }
    }, [location]);
 
    useLayoutEffect(() => {
        const checkVersion = async () => {
            try {
                const response = await axios.get(`/dist/version.txt?${Date.now()}`);
                const currentVersion = new Date(response.headers["last-modified"]).valueOf();
                if (!storedVersion) {
                    // If no version is stored in localStorage, assume it's the first visit and store the current version
                    setItemToStore("appVersion", currentVersion);
                } else if (currentVersion !== storedVersion) {
                    // New version detected, show SweetAlert notification
                    // setItemToStore("appVersion", currentVersion);
                    confirmAlert({ 
                        title            : "New Version Available",
                        text             : "A new version of the application is available. Please refresh the page.",
                        icon             : "info",
                        confirmButtonText: "Refresh",
                        showCancelButton : false,
                        allowOutsideClick: () => false,
                        preConfirm       : () => {
                            // Store the current version after the user confirms the notification
                            setItemToStore("appVersion", currentVersion);
                            // Refresh the page to load the new version
                            navigate(0);
                        }
                    });
                    setPopupOpen(true);
                }
            } catch (error) {
                console.error("Error checking version:", error);
            }
        };
        // if (import.meta.env.APP_ENV) {
        if (!popupOpen) {
            checkVersion();
            document.addEventListener("click", checkVersion);
        }
        // }
        return () => {
            document.removeEventListener("click", checkVersion);
        };
    }, [location, popupOpen]);
    
    useEffect(() => {
        window.addEventListener("storage", () => {
            setMenuCollapsed(getItemFromStore("menuCollapsed"));
        });
        // checkAdBlocker();
        // checkLogoutRequired();
    }, []);

    return (
        <>
            <div
                className={classnames("wrapper vertical-layout navbar-sticky", {
                    // Only apply these if not product route
                    "vertical-menu-modern": !isProductRoute && windowWidth >= 1111,
                    "menu-collapsed"      : !isProductRoute && menuCollapsed && windowWidth >= 1111,
                    "menu-expanded"       : !isProductRoute && !menuCollapsed && windowWidth >= 1111,

                    // Overlay Menu 
                    "vertical-overlay-menu": windowWidth < 1111,
                    "menu-hide"            : !menuVisibility && windowWidth < 1111,
                    "menu-open"            : menuVisibility && windowWidth < 1111,

                    // Sidebar logic
                    "no-sidebar" : isMenuHidden || isProductRoute,
                    "has-sidebar": !isMenuHidden && !isProductRoute
                })}
                {...((isMenuHidden || isProductRoute) ? { "data-col": "1-column" } : {})}>
                {!isMenuHidden && !isProductRoute ? (
                    <SidebarComponent
                        ability={ability}
                        menuData={menuData}
                        menuCollapsed={menuCollapsed}
                        menuVisibility={menuVisibility}
                        setMenuCollapsed={handleMenuCollapsed}
                        setMenuVisibility={setMenuVisibility}/>
                ) : null}
                {!menuHidden && !isProductRoute && <i
                    className={`mdi mdi-${
                        menuCollapsed ? "chevron-right" : "chevron-left"
                    } cursor-pointer text-dark font-medium-3 d-none d-xl-block nav-menu-icon`}
                    onClick={() => handleMenuCollapsed()}/>} 
                {showNavbar ? (
                    <Navbar
                        expand="lg"
                        container={false}
                        className={classnames( 
                            "header-navbar navbar align-items-center fixed-top border-bottom"
                        )}>
                        <div className="navbar-container d-flex content align-items-center">
                            <NavbarComponent
                                setMenuVisibility={setMenuVisibility}
                                setMenuCollapsed={handleMenuCollapsed}
                                menuCollapsed={menuCollapsed}
                                menuHidden={isMenuHidden}/>
                        </div>
                    </Navbar>
                ) : null}
                {children}
                {/* Vertical Nav Menu Overlay */}
                <div
                    className={classnames("sidenav-overlay", {
                        show: menuVisibility
                    })}
                    onClick={() => setMenuVisibility(false)}/>
            </div>
        </>
    );
};

export default Layout;